import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section
      id="home"
      className="pt-36 pb-28 bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800"
    >
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">

        {/* LEFT SIDE: IMAGE + TEXT INLINE */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="flex flex-col md:flex-row items-center md:items-start gap-8"
        >
          {/* IMAGE */}
         <img
  src="/ranjit.png"
  alt="Ranjit Gautam"
  className="w-44 h-44 md:w-56 md:h-56 rounded-full object-cover border-4 border-blue-600 shadow-lg flex-shrink-0"
/>


          {/* TEXT */}
          <div className="text-center md:text-left">
            <h2 className="text-4xl md:text-5xl font-extrabold leading-tight">
              Hi, I’m <span className="text-blue-600">Ranjit</span>
            </h2>

            <p className="mt-3 text-xl text-gray-600 dark:text-gray-300">
              Frontend Developer · React · Tailwind
            </p>

            <p className="mt-5 text-gray-600 dark:text-gray-400 max-w-md">
              I build modern, responsive and scalable web interfaces with a
              strong focus on clean UI and user experience.
            </p>

            <div className="mt-7 flex gap-4 justify-center md:justify-start">
              <a
                href="#projects"
                className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow hover:scale-105 transition"
              >
                View Projects
              </a>
              <a
                href="#contact"
                className="border px-6 py-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
              >
                Contact Me
              </a>
            </div>
          </div>
        </motion.div>

        {/* RIGHT SIDE CARD (UNCHANGED) */}
        <div className="hidden md:block">
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-xl">
            <p className="text-sm text-gray-500">Education</p>
            <h3 className="text-lg font-semibold mt-1">
              BSC.CSIT 
            </h3>
            <p className="mt-4 text-gray-600 dark:text-gray-300">
              Based in Butwal, Nepal 🇳🇵
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
